import * as React from 'react';
import Cookies from './Cookies';
var CookiesContext = /*#__PURE__*/React.createContext(new Cookies());
export var Provider = CookiesContext.Provider,
  Consumer = CookiesContext.Consumer;
export default CookiesContext;